import { AnyAction } from 'redux'
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { defaultFlow } from 'redux/config/saga/Common'
import { reimbursementsActions } from './reimbursementsSlice'
import reimbursementsService from './reimbursementsService'
import { ReimbursementSubmission } from './reimbursementsTypes'

// Employee saga
export function* getMySubmissions(action: AnyAction) {
  yield put(reimbursementsActions.setLoading(true))
  yield defaultFlow(
    action,
    reimbursementsService.getMySubmissions,
    reimbursementsActions.getMySubmissionsSuccess
  )
}

// Admin saga
export function* getAllEmployeeSubmissions(action: AnyAction) {
  yield put(reimbursementsActions.setLoading(true))
  yield defaultFlow(
    action,
    reimbursementsService.getAllEmployeeSubmissions,
    reimbursementsActions.getAllEmployeeSubmissionsSuccess
  )
}

export function* getEmployeeSubmissions(action: AnyAction) {
  yield put(reimbursementsActions.setEmployeeSubmissionsLoading(true))
  try {
    const res: { data: ReimbursementSubmission[] } = yield call(
      reimbursementsService.getEmployeeSubmissions,
      action.payload
    )
    yield put(
      reimbursementsActions.getEmployeeSubmissionsSuccess({
        employeeId: action.payload,
        receipts: res.data,
      })
    )
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error)
    yield put(reimbursementsActions.getEmployeeSubmissionsFailed(message))
  }
}

export function* getReceiptDetails(action: AnyAction) {
  yield put(reimbursementsActions.setLoading(true))
  yield defaultFlow(
    action,
    () => reimbursementsService.getReceiptDetails(action.payload),
    reimbursementsActions.getReceiptDetailsSuccess
  )
}

export function* watchGetMySubmissions() {
  yield takeEvery(reimbursementsActions.getMySubmissions.type, getMySubmissions)
}

export function* watchGetAllEmployeeSubmissions() {
  yield takeEvery(
    reimbursementsActions.getAllEmployeeSubmissions.type,
    getAllEmployeeSubmissions
  )
}

export function* watchGetEmployeeSubmissions() {
  yield takeLatest(
    reimbursementsActions.getEmployeeSubmissions.type,
    getEmployeeSubmissions
  )
}

export function* watchGetReceiptDetails() {
  yield takeEvery(
    reimbursementsActions.getReceiptDetails.type,
    getReceiptDetails
  )
}

export default function* reimbursementsSaga() {
  yield all([
    watchGetMySubmissions(),
    watchGetAllEmployeeSubmissions(),
    watchGetEmployeeSubmissions(),
    watchGetReceiptDetails(),
  ])
}
